/**
 * The submission revision a suitability decision is bound to (API rounds 13
 * to 15; Diego, 28 Oct: the seats that decide suitability see what they
 * decide).
 *
 * Every suitability (re)submission bumps the order's revision, in the same
 * transaction as its answers. A review item names the revision it was opened
 * for (meta.submission_rev), and the answers read names the revision of the
 * answers it returns (result.submissionRev, admin view only). A decision on a
 * page is about the answers that page shows, so it is offered only when the
 * two agree, and it sends the revision shown back to the API.
 */

const DIGITS = /^\d+$/;

/** A revision as stored or sent: a non-negative safe integer, a digit string, else null. */
function parseRevision(value) {
  if (typeof value === "number") return Number.isSafeInteger(value) && value >= 0 ? value : null;
  if (typeof value === "string" && DIGITS.test(value)) {
    const n = Number(value);
    return Number.isSafeInteger(n) ? n : null;
  }
  return null;
}

/** The revision the answers read returned (result.submissionRev), or null when it named none. */
export function submissionRevOf(result) {
  const rev = result ? result.submissionRev : undefined;
  return Number.isInteger(rev) && rev >= 0 ? rev : null;
}

/**
 * The revision a review item was opened for. An item opened before revisions
 * existed has none and stands for revision 0 (the API reads it the same way);
 * a value that cannot be read is null and never matches anything.
 */
export function itemSubmissionRev(item) {
  const meta = item && item.meta;
  const raw = meta ? meta.submission_rev : undefined;
  if (raw === undefined || raw === null) return 0;
  return parseRevision(raw);
}

/** Is this a SUITABILITY item about an order (the only kind whose decision writes one)? */
export function needsReviewedRevision(item) {
  return (
    !!item &&
    String(item.submission_type || "").toUpperCase() === "SUITABILITY" &&
    item.investment_id !== null &&
    item.investment_id !== undefined
  );
}
